module.exports = __webpack_public_path__ + "media/bootstrap-icons/trash-fill-252f3f75.svg";